/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protocol_Beginner_Full_Body_NameInputs */

const en_us2_protocol_beginner_full_body_name = /** @type {(inputs: Protocol_Beginner_Full_Body_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner`)
};

const pt_br2_protocol_beginner_full_body_name = /** @type {(inputs: Protocol_Beginner_Full_Body_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante`)
};

const es_419_protocol_beginner_full_body_name = /** @type {(inputs: Protocol_Beginner_Full_Body_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const pt_pt2_protocol_beginner_full_body_name = /** @type {(inputs: Protocol_Beginner_Full_Body_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const fr_fr2_protocol_beginner_full_body_name = /** @type {(inputs: Protocol_Beginner_Full_Body_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant`)
};

const de_de2_protocol_beginner_full_body_name = /** @type {(inputs: Protocol_Beginner_Full_Body_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger`)
};

const it_it2_protocol_beginner_full_body_name = /** @type {(inputs: Protocol_Beginner_Full_Body_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

/**
* | output |
* | --- |
* | "Beginner" |
*
* @param {Protocol_Beginner_Full_Body_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protocol_beginner_full_body_name = /** @type {((inputs?: Protocol_Beginner_Full_Body_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protocol_Beginner_Full_Body_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protocol_beginner_full_body_name(inputs)
	if (locale === "es-419") return es_419_protocol_beginner_full_body_name(inputs)
	if (locale === "pt-PT") return pt_pt2_protocol_beginner_full_body_name(inputs)
	if (locale === "fr-FR") return fr_fr2_protocol_beginner_full_body_name(inputs)
	if (locale === "de-DE") return de_de2_protocol_beginner_full_body_name(inputs)
	if (locale === "it-IT") return it_it2_protocol_beginner_full_body_name(inputs)
	return en_us2_protocol_beginner_full_body_name(inputs)
});
export { protocol_beginner_full_body_name as "protocol.beginner-full-body.name" }